import { useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// Gentle, dismissible strip shown across the app while a member is on their free trial.
// Dismissal is per-day so it returns the next day without nagging within a session.
export default function TrialBanner() {
  const { user } = useAuth();
  const access = user?.access;
  const key = `sh_trial_banner_${new Date().toISOString().slice(0, 10)}`;
  const [dismissed, setDismissed] = useState(() => {
    try { return sessionStorage.getItem(key) === "1"; } catch { return false; }
  });

  if (!access?.trial_active || dismissed) return null;
  const days = access.trial_days_left ?? 0;
  const label = days <= 0 ? "Your trial ends today" : `${days} day${days === 1 ? "" : "s"} left in your free trial`;

  const dismiss = () => {
    try { sessionStorage.setItem(key, "1"); } catch { /* noop */ }
    setDismissed(true);
  };

  return (
    <div data-testid="trial-banner"
      className="mb-5 flex items-center gap-3 rounded-2xl border border-[#C89B55]/40 bg-[#FBF4E7] px-4 py-2.5">
      <Sparkles size={16} className="text-[#C89B55] shrink-0" />
      <p className="text-sm text-[#7A5A1E] flex-1 leading-snug">
        <span className="font-semibold">{label}.</span>{" "}
        <Link to="/paywall" data-testid="trial-banner-subscribe" className="underline hover:text-[#291B2D]">
          Subscribe to keep everything
        </Link>
      </p>
      <button onClick={dismiss} aria-label="Dismiss" data-testid="trial-banner-dismiss"
        className="text-[#7A5A1E]/60 hover:text-[#7A5A1E] shrink-0">
        <X size={16} />
      </button>
    </div>
  );
}
